<template>
    <div class="container">
        <div v-wechat-title="$route.meta.title"></div>
        <div class="app-container">
            <div class="list" v-for="(item, index) in listData" :key="index">
                <div class="title">
                    {{ item.question }}
                    <i>{{index+1}}</i>
                </div>
                <div class="content" v-for="(item,index) in item.answer" :key="index" v-html="item"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { Params, getSessionId, getUid, browser, setSessionId, setUid } from "../util/util.js";
import Qs from "qs";
import Header from './Header';
export default {
    name: 'question',
    data: function(){
        return {
            listData: [{
                id: 1,
                question: ' كيف تتحقق من إضافة العملات بعد الشحن بنجاح؟',
                answer: ['يرجى التحقق من الرصيد في [أنا] - [المحفظة] بعد الشحن ، وستتم إضافة العملات المعدنية في الوقت الفعلي']
            },{
                id: 2,
                question: ' ماذا تفعل إذا لم يتم إضافة العملات بعد الشحن؟',
                answer: [' الرجاء إرسال ملاحظة بخصوص مشكلتك بالمعلومات التالية بواسطة [أنا] - [ملاحظات]. سيساعدك فريق خدمة العملاء لدينا في حل مشكلتك ',
                    'مبلغ الشحن ①',
                    'تاريخ ووقت الشحن ②',
                    ' <span> الطلب ID </span> لقطة شاشة لإيصال الدفع يظهر ③'
                ]
            },{
                id: 3,
                question: 'ماذا أفعل إذا قمت بشحن حساب شخص اخر عن طريق الخطأ؟',
                answer: [' نأسف أن رد الأموال غير مسموح به. يرجى محاولة التواصل مع مالك الحساب بشأن عملية الشحن الغير صحيحة ومحاولة تغطية خسارتك ']
            }],
            userId: '',
            backToTop: false,
        }
    },
    methods: {
        scrollToTop(selector){
            const element = selector && document.querySelector(selector) || window;
            element.scrollTo(0, 0);
        }
    },
    created(){
        console.log(this.$store.state.userInfo)
        this.scrollToTop();
    },
    mounted() {
        
    }
}
</script>

<style scoped>
    .container{
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .app-container{
        width: 100%;
        height: 100%;
        padding-left: 0.09rem;
        padding-right: 0.12rem;
        box-sizing: border-box;
    }
    .list{
        margin-top: 0.38rem;
        text-align: right;
        padding-bottom: 0.2rem;
        padding-right: 0.21rem;
        border-bottom: 1px solid #F3F7FF;
    }
    .title{
        margin-bottom: 0.1rem;
        position: relative;
        font-size: 0.15rem;
        font-weight: 800;
        color: #0E0F16;
    }
    .title i{
        content: '';
        display: block;
        position: absolute;
        right: -0.21rem;
        top: 0;
        width: 0.18rem;
        height: 0.16rem;
        text-align: center;
        line-height: 0.16rem;
        color: #FFF;
        font-size: 0.12rem;
        font-style: inherit;
        font-weight: 600;
        background: #E355D8;
        border-radius: 50% 50% 50% 0;
    }
    .content{
        font-size: 0.1rem;
        font-weight: bold;
        color: #0E0F16;
    }
</style>


// WEBPACK FOOTER //
// src/components/Question.vue